import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import {
  GlowWalletAdapter,
  PhantomWalletAdapter,
  SlopeWalletAdapter,
  SolflareWalletAdapter,
  TorusWalletAdapter,
  LedgerWalletAdapter,
  SolletExtensionWalletAdapter,
  SolletWalletAdapter,
} from '@solana/wallet-adapter-wallets';
import { clusterApiUrl, Cluster } from '@solana/web3.js';
import { useMemo } from 'react';

type NetworkInfo = {
  uri: string,
  network: Cluster,
  adapter: string,
}

const devNet: NetworkInfo = {
  uri: "https://api.devnet.solana.com",
  network: "devnet",
  adapter: "Devnet",
}

// const testNet: NetworkInfo = {
//   uri: "https://api.testnet.solana.com",
//   adapter: "Testnet",
//   network: "testnet",
// }

const mainNet: NetworkInfo = {
  uri: "https://lively-floral-bird.solana-mainnet.discover.quiknode.pro/46c14da591a3c89da93cd028aa82fa09e5c67f0d/",
  adapter: "Mainnet",
  network: "mainnet-beta",
}

let defaultNet = mainNet;

const WalletContext = ({ children }) => {
  // The network can be set to 'devnet', 'testnet', or 'mainnet-beta'.
  const network = WalletAdapterNetwork[defaultNet.adapter];

  // You can also provide a custom RPC endpoint.
  const endpoint = useMemo(() => clusterApiUrl(network), [network]);

  // @solana/wallet-adapter-wallets includes all the adapters but supports tree shaking and lazy loading --
  // Only the wallets you configure here will be compiled into your application, and only the dependencies
  // of wallets that your users connect to will be loaded.
  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new GlowWalletAdapter(),
      new SlopeWalletAdapter(),
      new SolflareWalletAdapter({ network }),
      new TorusWalletAdapter(),
      new LedgerWalletAdapter(),
      new SolletExtensionWalletAdapter(),
      new SolletWalletAdapter(),
    ],
    [network]
  );
  

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>{children}</WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
};

export { WalletContext, defaultNet };